<template>
  <b-modal :id="id" title="Edit Client" @show="resetModal" @hidden="resetModal" @ok="handleOk">
    <b-table
      stacked
      :borderless="true"
      :fields="[
          {
            key: 'id',
            label: 'ID',
            sortable: true
          },
          {
            key: 'username',
            label: 'Name',
            sortable: true
          },
        ]"
      :items="[client]"
    >
      <template v-slot:cell(username)>
        <b-form-input type="text" v-model="newName"></b-form-input>
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button size="sm" variant="primary" class="bg-site-primary" @click="ok()">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `ClientEditModal`,
  data() {
    return {
      newName: null
    };
  },
  props: {
    id: {
      type: String
    },
    client: {
      type: Object
    }
  },
  watch: {
    client(newClient) {
      this.newName = newClient && newClient.user ? newClient.user.username : null
    },
  },
  methods: {
    filterNumberOnly(evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      else{
        if(isNaN(this.newCredits) || this.newCredits < 0){
          this.newCredits = 0
        }
        return true
      }
    },  
    resetModal() {
      
    },
    handleOk(){
      // Check if Value changed
      const userId = this.client.user.id,
      username = this.newName,
      isUserChanged = username != this.client.user.username

      return new Promise((resolve) => {
        if(isUserChanged)
         resolve(this.$store.dispatch(`user/update`, { id: userId, data : { username } }))
      })
      .then(()=>{
        this.$emit('ok')   
      })
    }
  },

};
</script>

<style lang="scss" scoped>
</style>